/**
 * The steps of the competition creation wizard, in order — `getNextScreen` /
 * `getPrevScreen` in `CreateEditCompetition` walk the numbers, so the order is
 * the flow.
 *
 * Lives here rather than in the competition slice because `constants/index.ts`
 * keys `REQUIRED_FIELDS_COMPETITION` off it. Importing it from the slice made
 * `constants` depend on the redux graph at runtime, and that graph comes back
 * round to `constants`: the cycle left `auth.ts` reading `PHONE_TAKEN_MESSAGE`
 * while `constants` was still evaluating, which threw a TDZ ReferenceError
 * before the app rendered anything at all. Constants must stay a leaf.
 */
export enum CompetitionCreationScreens {
  BasicDetails,
  Questions,
  Settings,
  Rewards,
  PageContent,
  AdminSettingsAndPublish,
}

export default CompetitionCreationScreens;
